import { useState } from "react";
import { useSuspenseQuery } from "@tanstack/react-query";

import { getScenariosCategories } from "~/data/dashboard/dashboard.service";

import { Dialog } from "../shared/dialog";
import { ScenariosByCategory } from "../scenarios/scenarios-by-category";

export function ScenariosSection() {
  const { data } = useSuspenseQuery({
    queryKey: ["scenarios_categories"],
    queryFn: () => getScenariosCategories(),
    staleTime: Infinity,
  });
  const [selectedCategory, setSelectedCategory] =
    useState<(typeof data.categories)[0]>();

  return (
    <section className="rounded-[20px] bg-white shadow-card p-5">
      <h2 className="text-[#2D2D2D] font-alternative font-semibold text-2xl uppercase mb-1">
        Todos os cenários{" "}
        <span className="align-middle text-base">({data.total_scenarios})</span>
      </h2>
      <p className="mb-5">
        Cenários possuem checklists e possibilidade de anexar vários exames
      </p>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-6">
        {data.categories.map((category) => (
          <button
            key={category.id}
            className="flex px-4 py-5 rounded-[20px] h-[150px] border-l-[6px] border-l-alternative-2 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `linear-gradient(90deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0.00) 100%), url('${
                import.meta.env.VITE_API_URL + category.banner_url
              }')`,
            }}
            type="button"
            onClick={() => setSelectedCategory(category)}
          >
            <div className="py-1 px-2">
              <h3 className="text-start text-alternative-2 font-alternative text-lg font-semibold uppercase">
                {category.name}
              </h3>
              <p className="text-start text-surface text-sm font-alternative">
                {category.user_tests} Práticas realizadas
              </p>
            </div>
          </button>
        ))}
      </div>

      <Dialog
        open={!!selectedCategory}
        onOpenChange={() => setSelectedCategory(void 0)}
      >
        <Dialog.Content className="w-11/12 max-w-screen-2xl">
          {!!selectedCategory && (
            <ScenariosByCategory category={selectedCategory} className="pt-6" />
          )}
        </Dialog.Content>
      </Dialog>
    </section>
  );
}
